import { useConfirmPendingAssessment } from "@/api/console/pending-assessments/useConfirmPendingAssessment";
import { useGetPendingAssessment } from "@/api/console/pending-assessments/useGetPendingAssessment";
import AdminContentContainer from "@/components/AdminContentContainer";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import BottomBar from "@/components/BottomBar";
import LoadingScreen from "@/components/Loading";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { handleCompanyUserName } from "@/lib/handleName";
import toast from "@/lib/toast";
import Heading from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/_components/Heading";
import AssessmentInfo from "@/src/console/(auth)/_components/CheckingAssessment/AssessmentInfo";
import CategoriesSection from "@/src/console/(auth)/_components/CheckingAssessment/CategoriesSection/CategoriesSection";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

function CheckSubmissionDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      name: t("check-submissions"),
      href: "/console/check-submissions",
    },
    {
      name: t("assessment-details"),
      href: location.pathname,
    },
  ];

  const { id = "" } = useParams();
  const { data, isLoading, mutate } = useGetPendingAssessment(id);

  const { trigger, isMutating } = useConfirmPendingAssessment(id, {
    onSuccess: (data) => {
      toast.success(data.message);
      navigate("/console/check-submissions");
    },
    revalidate: false,
  });

  if (isLoading || !data) return <LoadingScreen />;
  const {
    answer_categories,
    company,
    company_document_files,
    submitted_by,
    submitted_at,
  } = data.data;
  const disabled = answer_categories.some((category) => !category.is_checked);

  return (
    <Tabs defaultValue="categories">
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <AdminContentContainer
        bottomBar={<BottomBar backLink="/console/check-submissions" />}
      >
        <Heading
          isConfirming={isMutating}
          disabled={disabled}
          onConfirm={() => {
            toast.loading(t("confirm-assessment-loading"));
            trigger();
          }}
        />
        <div className="m-6">
          <TabsContent value="categories">
            <CategoriesSection data={answer_categories} />
          </TabsContent>
          <TabsContent value="assessment info">
            <AssessmentInfo
              companyInfo={company}
              documents={company_document_files}
              submittedAt={submitted_at}
              submittedBy={handleCompanyUserName(
                submitted_by.id,
                submitted_by.name,
              )}
            />
          </TabsContent>
        </div>
      </AdminContentContainer>
    </Tabs>
  );
}

export default CheckSubmissionDetail;
